import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // Authentication is carried explicitly in the Authorization header. Never
  // opt this shared cross-origin client into ambient cookie credentials.
  withCredentials: false,
});

export function setAuthHeader(token?: string) {
  const key = 'Authorization';
  if (token) {
    httpClient.defaults.headers.common[key] = `Bearer ${token}`;
  } else {
    delete httpClient.defaults.headers.common[key];
  }
}

export default httpClient;



// WEBPACK FOOTER //
// ./src/clients/http.client.ts